//表单页面
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Input, Table, Modal, Radio, Button } from 'antd';
// import MyModal from './modal';
import axios from 'axios'
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { formatAuth, formatVipGrade } from '../util/format';
import { sanitizeHtml } from '../util/sanitizeHtml';

//state映射
const mapStateToProps = (state) => {
    return {
        currentData: state.currentData
    }
}
var currentData = {}
const { TextArea } = Input;
var token = localStorage.getItem('token')
var rows = []
var auditMessage = ""
const MyModal = ({onSubmit}) => {
    //审核弹窗
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
        console.log(111, currentData);
    };
    const handleOk = () => {
        console.log(123123, value);
        setIsModalOpen(false);
        const data = {
            taskId: currentData.id,
            auditMessage: auditMessage,
            taskStatus: value
        }

        const fetchData = async () => {
            await axios
                .post("/api/task/auditTask", data, { headers: { 'X-Access-Token': token } })
                .then((res) => {
                    console.log(res);
                });
            await axios
                .post("/api/task/findUnApproveTaskList", {
                    "pageSize": 10,
                    "pageNum": 1,
                    "firstNum": 1
                }, { headers: { 'X-Access-Token': token } })
                .then((res) => {
                    onSubmit(res)
                });
        }
        fetchData()


    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };



    const [value, setValue] = useState(1);
    const onChange = (e) => {

        console.log('radio checked', e.target.value);
        setValue(e.target.value);
        console.log(123, value);

    };
    const valueChange = (e) => {

        auditMessage = e.target.value



    }
    return (
        <>
            <a type="primary" onClick={showModal} className='a'>
                审核
            </a>

            {/* <a type="primary" onClick={showModal2}>
                详情
            </a> */}
            <Modal title="任务审核" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[<Button key="back" onClick={handleCancel}>
                取消
            </Button>,
            <Button key="submit" type="primary" onClick={handleOk}>
                保存
            </Button>]}>
                <div className='modalF'>
                    <div>任务标题：{currentData.title}</div>
                    <div>任务赏金：{currentData.money}</div>
                    <div>是否紧急：{currentData.exigence == 0?"非紧急":"紧急"}</div>
                    <div style={{ display: 'flex' }}><div style={{ width: '50%' }}>任务领域：{currentData.domain}</div><div>难易程度：{currentData.complexity==='1'?"容易":currentData.complexity==='2'?"中等":"复杂"}</div></div>
                    <div>线上/线下：{currentData.type==='1'?"线上":"线下"}</div>
                    <div style={{ display: 'flex' }}><div style={{ width: '50%' }}>发布者：{currentData.nickName}</div><div>ID：{currentData.number}</div></div>
                    <div style={{ display: 'flex' }}><div style={{ width: '50%' }}>实名认证：{formatAuth(currentData.auth)}</div><div>会员等级：{formatVipGrade(currentData.vipGrade)}</div></div>
                    <div style={{ display: 'flex' }}><div style={{ width: '50%' }}>发布时间：{currentData.createTime}</div><div>截止时间：{currentData.deadline}</div></div>
                    <div>完成地点：{currentData.offlineLocation}</div>
                    <div>任务描述：<span dangerouslySetInnerHTML={{ __html: sanitizeHtml(currentData.taskContent) }} /></div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ padding: '10px 20px 20px 0' }}    >任务审核</div>
                        <Radio.Group onChange={onChange} value={value} className="radio1">
                            <Radio value={3}>通过</Radio>
                            <Radio value={2}>不通过</Radio>
                        </Radio.Group>
                    </div>
                </div>
                <TextArea rows={4} onChange={valueChange} />

            </Modal>
            {/* <Modal title="任务详情" open={isModal2Open} onOk={handleOk2} onCancel={handleCancel2}>
                <p>Some contents...</p>

            </Modal> */}
        </>
    );
};

const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current?.focus();
        }
    }, [editing]);
    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({
                ...record,
                ...values,
            });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <Input ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingInlineEnd: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};
//在这里写

const MyTable = () => {
    const [dataSource, setDataSource] = useState(rows);
    function handleSubmit(res){
        console.log('传过去啦',res);
        setDataSource(res.data.data.rows)
    }
    const navigate = useNavigate()
    const toLogin = ()=>{
        navigate('/login')
    }
    useEffect(() => {
        // 使用浏览器的 API 更新页面标题
        const fetchData = async () => {
            token = localStorage.getItem('token')
            if(token!==null){
                await axios
                .post("/api/task/findUnApproveTaskList", {
                    "pageSize": 10,
                    "pageNum": 1,
                    "firstNum": 1
                }, { headers: { 'X-Access-Token': token } })
                .then((res) => {
                    if (res.data.code==401){
                        localStorage.clear()
                        toLogin()
                    }else{
                        rows = res.data.data.rows
                    
                        setDataSource(res.data.data.rows)
                    
                    }
                    
                });
            }
            
        }
        fetchData()
    }, []);



    const defaultColumns = [
        {
            title: '任务名称',
            dataIndex: 'title',
            editable: true,
        },
        {
            title: '任务内容',
            dataIndex: 'taskContent',
            render: (text) => <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }} />,
        },
        {
            title: '发布者',
            dataIndex: 'nickName',
        },
        {
            title: '发布时间',
            dataIndex: 'createTime',
        },
        {
            title: '到期时间',
            dataIndex: 'deadline',
        },
        {
            title: '任务状态',
            dataIndex: 'taskStatus',
        },
        {
            title: '当前状态',
            dataIndex: 'taskStatus',
        },
        {
            title: '操作',
            dataIndex: 'operation',
            render: () =>
                <MyModal currentData={currentData} onSubmit={handleSubmit}/>
        },
        {
            title: '推荐权重',
            dataIndex: 'complexity',
        },
    ];
    //用


    const handleSave = (row) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setDataSource(newData);
    };
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };
    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    return (
        <div className='table'>
            <Table
                components={components}
                rowClassName={() => 'editable-row'}
                bordered
                dataSource={dataSource}
                columns={columns}
                onRow={(record) => {
                    return {
                        onClick: () => {
                            // setCurrentData(record)
                            currentData = record
                            console.log(record.auth);


                            // currentData = record;
                        }
                    }
                }}

            />
        </div>
    );
};
//rudux
export default connect(mapStateToProps)(MyTable);